import type * as React from "react";

import { cx } from "../../lib/cx";
import s from "./FormGrid.module.css";

export type FormGridProps = React.ComponentPropsWithoutRef<"div">;

/** Grilla de campos: una columna en celular, dos desde escritorio. Cada hijo directo es una celda. */
export function FormGrid({ className, ...rest }: FormGridProps) {
  return <div className={cx(s.grilla, className)} {...rest} />;
}

export interface FormRowProps extends React.ComponentPropsWithoutRef<"div"> {
  /** `full` ocupa las dos columnas (una dirección, un textarea, la fila de botones). */
  span?: "full";
}

/** Una celda de `FormGrid`. Sólo hace falta cuando hay que ocupar las dos columnas. */
export function FormRow({ span, className, ...rest }: FormRowProps) {
  return <div className={cx(s.fila, className)} data-span={span} {...rest} />;
}
